import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Page } from 'src/app/models/page.model';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-quickscandetail',
  templateUrl: './quickscandetail.page.html',
  styleUrls: ['./quickscandetail.page.scss'],
})
export class QuickscandetailPage implements OnInit {

  
  quickscanId: string;
  quickscan: any = {};
  showPage: boolean = false;
  preventClick: boolean = true;
  toggleSubscription: Subscription;
  itemsSelected = []
  AllLocales = []


  locale: any;
  tempLocale: any;

  quickScanForm: FormGroup;
  submitted = false;

 



  constructor(private formBuilder: FormBuilder, private location: Location, private _apiService: ApiService, public _commonService: CommonService, private route: ActivatedRoute, private router: Router) 
  {}

  ngOnInit() {
    this.quickScanForm = this.formBuilder.group({
      Name: ['', Validators.required],
      Description: ['', Validators.required],
    });
  }

  ionViewDidEnter(){
    this.quickscanId = this.route.snapshot.paramMap.get('id');
    this.locale = Number((localStorage.locale && localStorage.locale != '') ? localStorage.locale : 1043);
    this.tempLocale = this.locale;
    if (this.quickscanId == '0') {
      this.quickscanId = null;
    }
    if (this.quickscanId) {
      this.getQuickScanDetails();
    }else{
      this.getLocales();
      this.showPage = true;
      this.quickscan =
        {
          QuickScanId: this.quickscanId,
          Description: '',
          Name: ''
        }
    }
  }



  async getQuickScanDetails(){
    this._commonService.presentLoading();
     try {
       let res = await this._apiService.getQuickScanDetail(this.quickscanId);
        this.quickscan = res.body;
       
       this._commonService.log(this.quickscan, this._commonService.LOG);
 
       this.quickScanForm.patchValue({
          Description: this.quickscan.Description,
          Name: this.quickscan.Name
         
        });
      this.quickScanForm.updateValueAndValidity();
      this.showPage = true;
      this._commonService.dismiss();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR)
    }
  }


  async getLocales() {
    try {
      if (localStorage.domainLocales) {
        this.AllLocales = JSON.parse(localStorage.domainLocales);
        for (let i = 0; i < this.AllLocales.length; i++) {
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-nl') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/nl.svg'
          }
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-gb') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/gb.svg'
          }
        }
      } else {
        let localeData = await this._apiService.getDomainLocales('', 1, 0);
        this.AllLocales = localeData.body;
        for (let i = 0; i < this.AllLocales.length; i++) {
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-nl') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/nl.svg'
          }
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-gb') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/gb.svg'
          }
        }
        localStorage.domainLocales = JSON.stringify(localeData.body);
      }
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  get f() { return this.quickScanForm.controls; }

  async onSubmit() {
    this.submitted = true;

    if (this.quickScanForm.invalid) {
      this._commonService.scrollToError();
      return;
    }
 
    this._commonService.presentLoading();
    try {
      let data = {
        Description: this.quickScanForm.value.Description,
        Name: this.quickScanForm.value.Name,
        QuickScanId: null
      }
     
      let res = await this._apiService.postQuickScan(data);
      if(res.id){
        this.quickscanId = res.id;
        sessionStorage.routeFrom = "listPage";
        this.router.navigate(['maintenance/quickscan/'+this.quickscanId+'/tree'], { replaceUrl: true });
        // this.location.replaceState('maintenance/quickscan/' + this.quickscanId);
      }
      this._commonService.dismiss();
      this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
      this._commonService.log(data, this._commonService.LOG);
      this.submitted = false;
     // this.getQuickScanDetails();
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  onReset() {
    this.submitted = false;
    this.quickScanForm.reset();
  }


  ionViewDidLeave() {

  }

  delete() {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          await this._apiService.deleteQuickScan(this.quickscanId);
          this._commonService.dismiss();
          this._commonService.log(res, this._commonService.LOG);
          this.goBack();
        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }

  goBack() {
    this.location.back();
  }
  

  onSelect(event) {
    let selected = [];
    event.selected.forEach(element => {
      selected.push(element.ObjectGroupId);
    });
    this.itemsSelected = selected;
  }



  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
          this.onSubmit();
          break;
      case "delete":
          this.delete();
          break;
      case "backToList":
          this.goBack();
          break;
      case "backToMain":
          this.router.navigate(['maintenance'], { replaceUrl: true })
          break;
      case "back":
          this.goBack();
          break;
      }
      
  }

  changeLocale(){}


}
